module.exports = __webpack_public_path__ + "img/men_old.1f4a41cb.png";